var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPen = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.024 18.125H1.875v-2.148L13.99 3.832 16.17 6.01 4.024 18.125Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.63 5.547 14.453 3.37l1.237-1.197c.19-.193.484-.298.755-.298a1.011 1.011 0 0 1 .72.298l.664.664a1.01 1.01 0 0 1 .296.718c0 .273-.106.564-.298.756L16.63 5.547Z",
  fill: "currentColor"
})));
export { SvgPen as ReactComponent };